function r(t){return Object.is(t,-0)?"-0":t.toString()}export{r as toKey};
